var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-tabs__challenge__time_indices" }, [
    _c(
      "div",
      { staticClass: "countdown-box" },
      [
        _vm.isShowDays
          ? [
              _c("span", { staticClass: "time-item" }, [
                _vm._v(_vm._s(_vm.days[0])),
              ]),
              _c("span", { staticClass: "time-item" }, [
                _vm._v(_vm._s(_vm.days[1])),
              ]),
              _c("span", { staticClass: "time-text" }, [_vm._v("天")]),
            ]
          : _vm._e(),
        _c("span", { staticClass: "time-item" }, [
          _vm._v(_vm._s(_vm.hours[0])),
        ]),
        _c("span", { staticClass: "time-item" }, [
          _vm._v(_vm._s(_vm.hours[1])),
        ]),
        _c("span", { staticClass: "time-text" }, [_vm._v("时")]),
        _c("span", { staticClass: "time-item" }, [
          _vm._v(_vm._s(_vm.minutes[0])),
        ]),
        _c("span", { staticClass: "time-item" }, [
          _vm._v(_vm._s(_vm.minutes[1])),
        ]),
        _c("span", { staticClass: "time-text" }, [_vm._v("分")]),
        _c("span", { staticClass: "time-item" }, [
          _vm._v(_vm._s(_vm.seconds[0])),
        ]),
        _c("span", { staticClass: "time-item" }, [
          _vm._v(_vm._s(_vm.seconds[1])),
        ]),
        _c("span", { staticClass: "time-text" }, [_vm._v("秒")]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }